/**
 * CustCarousel.tsx — Thin wrapper around `CommonCarouselComponent` for
 * displaying a carousel of pre-built card components.
 *
 * JSON trigger: `uiCompType.method: "renderCustCarousel"`
 * Also used internally by `CategoriesCarousel` and `ProductsCarousel`.
 *
 * **Data field:** `sectionData.items` — Array of card data objects that have
 * already been transformed into the `CommonCarouselComponent` card shape by the
 * calling component (`CategoriesCarousel` → `prepareCardsForCategoriesGrid`,
 * `ProductsCarousel` → `prepareCardsForBuilderProductsGrid`).
 *
 * **Delegates to:** `CommonCarouselComponent` (`@/app/components/carousal/common_carousel`).
 *
 * **Style slots:** `uiCompType.styles` (outer container), `uiCompType.options.height`,
 * `uiCompType.options.width` forwarded as card dimensions.
 */
import React from "react";
import { Grid } from "@mui/material";
import CommonCarouselComponent from "@/app/components/carousal/common_carousel";
import cssStyles from "./cms_renderer.module.scss";
import { SectionData, ComponentRenderProps } from "./index";
import Title from "./Title";

interface CustCarouselProps {
    sectionData: SectionData;
    props: ComponentRenderProps;
}

const CustCarousel = ({ sectionData, props }: CustCarouselProps): JSX.Element | null => {
    const panelClassName = "carousel";
    return (
        <>
            {sectionData.title && <Title sectionData={sectionData} props={props} />}
            <Grid container className={cssStyles[panelClassName + "Container"]}>
                <CommonCarouselComponent fullWidth={true} type="scrollable"
                    cards={sectionData.items?.map((item: any) => (
                        <Grid key={item.name} item>{item}</Grid>
                    ))} />
            </Grid>
        </>
    );
};

export default CustCarousel;
